// Angular
import { Component, inject } from "@angular/core";
import { Params, Router } from "@angular/router";

// RXJS
import { Subject, takeUntil } from "rxjs";

// Models
import { NavigationLayoutItem, NavigationLayoutList } from "#models/navigation";
import { PromoType } from "#models/promo";

// Services
import { FileManagerService } from "#services/file-manager/file-manager.service";
import { FormDataService } from "#services/form-data/form-data.service";

// Others
import { getNavigationList } from "./navigation-base.component.data";

@Component({
    selector: "app-navigation-base",
    imports: [],
    template: "",
})
export class NavigationBaseComponent {
    list!: NavigationLayoutList;
    queryParamsMap = new Map();
    promoTypes: PromoType[] = [];

    protected destroy$ = new Subject<void>();

    protected readonly fileManagerService = inject(FileManagerService);
    protected readonly formDataService = inject(FormDataService);
    protected readonly router = inject(Router);

    constructor() {
        this.list = getNavigationList(() => this.showFileManager());

        this.formDataService
            .get({
                endpoint: "/promos/filters",
                dataKey: "types",
                cacheDuration: Infinity,
            })
            .pipe(takeUntil(this.destroy$))
            .subscribe((response) => {
                this.promoTypes = response.data["types"];
            });
    }

    getQueryParamsForLink(item: NavigationLayoutItem) {
        const queryParams = item.queryParams;
        if (
            item.matcher === "promos" &&
            this.promoTypes.length &&
            queryParams &&
            queryParams["filters[type_id]"] &&
            isNaN(Number(queryParams["filters[type_id]"]))
        ) {
            queryParams["filters[type_id]"] =
                this.promoTypes.find(
                    (promoType) => promoType.key === queryParams["filters[type_id]"]
                )?.id || queryParams["filters[type_id]"];
        }

        return item.withCurrentQuery ? this.mergeQueryParams(queryParams) : queryParams;
    }

    protected getQueryParams() {
        if (this.queryParamsMap.has(this.router.url)) {
            return this.queryParamsMap.get(this.router.url);
        }

        const queryParams = this.router.parseUrl(this.router.url).queryParams;
        this.queryParamsMap.set(this.router.url, queryParams);

        return queryParams;
    }

    protected showFileManager() {
        this.fileManagerService.show();
    }

    protected mergeQueryParams(params: Params | undefined) {
        if (params) {
            const newQueries = {
                ...this.getQueryParams(),
                ...params,
            };

            Object.entries(newQueries).forEach(([key, value]) => {
                if (value === null) {
                    delete newQueries[key];
                }
            });

            return newQueries;
        }

        return undefined;
    }
}
